
export default () => ({
    lang: localStorage.getItem("locale") ? localStorage.getItem("locale") : "es"
})